export default __webpack_public_path__ + "static/media/coreValueImg.a07abfa8.svg";